<!-- 商户资料提交 -->

<template>
    <div class="createCode">
        <div class="tableConBox">
            <div class="tableTem">
                <div class="HSpace1"></div>
                <div class="codeBox">
                    <!-- <div class="titles">
                        下载中心<span class="note"> * （微信扫码点单，电脑点单，均需开通在线支付功能才能使用）</span>
                        <router-link :to="{path:'/sys/'+$route.params.id+'/merCert'}" class="note">去开通</router-link>
                    </div> -->
                    <div class="download-cont">
                        <div class="dl-btn">
                            <!-- <a href="https://images.huoxingy.com/火星捕手收银端.rar">
                                <div class="btn-item pos">
                                    <i class="iconfont icon-qiandai"></i>
                                    <span>收银端XP下载</span>
                                </div>
                            </a> -->
                            <!-- <a href="http://hxypic.oss-cn-hangzhou.aliyuncs.com/%E7%81%AB%E6%98%9F%E6%8D%95%E6%89%8B%E6%94%B6%E9%93%B6%E7%AB%AF-WIN7.rar">
                                <div class="btn-item pos-for-xp">
                                    <i class="iconfont icon-qiandai"></i>
                                    <span>收银端WIN7/WIN10下载</span>
                                </div>
                            </a> -->
                            <!-- <a href="https://images.huoxingy.com/收银端0804.rar"> -->
                            <a href="https://images.huoxingy.com/火星捕手点单系统安装包_V1.1.2.exe.zip">
                                <div class="btn-item pos-for-tag">
                                    <i class="iconfont icon-qiandai"></i>
                                    <span>收银端下载</span>
                                </div>
                            </a>
                            <!-- <a href="/static/tagSoftware/标签打印机校准工具.zip">
                                <div class="btn-item pos-for-xp">
                                    <i class="iconfont icon-qiandai"></i>
                                    <span>标签打印校正工具下载</span>
                                </div>
                            </a> -->
                            <!-- <a href="https://images.huoxingy.com/update.rar">
                                <div class="btn-item pos-for-xp">
                                    <i class="iconfont icon-qiandai"></i>
                                    <span>Update</span>
                                </div>
                            </a> -->
                            <a :href="configUrl">
                            <!-- <div @click.stop="getZip"> -->
                                <div class="btn-item pc-order" @click="getZip">
                                    <i class="iconfont icon-shoujishumadiannao"></i>
                                    <span>购物点餐/呼叫客户端下载</span>
                                </div>
                            </a>
                            <!--  -->
                            <!-- <template v-if="hasCall=='true'"> -->
                            <template>
                                <!-- <a :href="'https://images.huoxingy.com/callClient/'+curStoreId+'.zip'">
                                    <div class="btn-item client">
                                        <i class="iconfont icon-shoujishumadiannao"></i>
                                        <span>呼叫客户端下载</span>
                                    </div>
                                </a> -->
                                <a :href="'https://images.huoxingy.com/service/'+curStoreId+'.zip'">
                                    <div class="btn-item service">
                                        <i class="iconfont icon-shoujishumadiannao"></i>
                                        <span>呼叫服务端下载</span>
                                    </div>
                                </a>
                            </template>
                            <!--  -->
                        </div>
                        <div class="qr-code" style="display:none;">
                            <div class="codes">
                                <div class="codeImg">
                                    <div id="qrcode" class="position-middle-center"></div>
                                </div>
                                <div class="codeNote">
                                    <span>微信点单二维码</span>
                                    <div class="downmobile">请在电脑下载二维码</div>
                                </div>
                            </div>
                        </div>
                        <!-- 店铺固定二维码 -->
                        <div class="qr-code">
                            <div class="codes">
                                <div class="codeImg">
                                    <div id="qrcodeForVip" class="position-middle-center"></div>
                                </div>
                                <div class="codeNote">
                                    <span>店铺会员二维码</span>
                                    <!-- <a href="javascript:;" @click="downLoadQrcodeForVip">点击下载</a> -->
                                </div>
                            </div>
                        </div>
                        <!-- end -->
                    </div>
                    <div class="downINpc">
                        客户端 请在电脑查看并下载
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import echarts from 'echarts';
    import {API_BASE_URL,BASE_URL} from "./../../../urlConfig/index";
    export default{
        props: ['curStoreId','storeData'],
    	data () {
    		return {
                hasCall:"",
                url:'',
                configUrl:'',
                batUrl:'',
                options: [{
                  value: '选项1',
                  label: '360极速浏览器'
                },],
                value: '',
    		}
    	},
        methods: {
            getZip(){
                this.$message({
                    message: '下载中，请稍等...',
                    customClass: 'success',
                    duration:5900
                })
                // this.$http({
                //     url:"/clientGet",
                //     method:"GET",
                //     params:{
                //         storeId:this.curStoreId,
                //         base:"huoxingy.zip",
                //     }
                // })
            },
            downLoadQrcodeForVip(){
                let qrcodeForVipDom = document.getElementById("qrcodeForVip");
                let cans = qrcodeForVipDom.children[0];
                // console.log(qrcodeForVipDom.children[0]);
                function imgType(ty) {
                    let type = ty.toLowerCase().replace(/jpg/i, 'jpeg');
                    var r = type.match(/png|jpeg|bmp|gif/)[0];
                    return 'image/' + r;
                }
                let saveFile = function(data, fileName){
                    let save_link = document.createElement('a');
                    save_link.href = data;
                    save_link.download = fileName;
                    // if (userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera) { 
                    //     console.log('ie')
                    //     // return;
                    //  }; //判断是否IE浏览器
                    let event = document.createEvent('MouseEvents');
                    event.initEvent("click", true, false);
                    save_link.dispatchEvent(event);
                };
                let type = "png";
                let img_png_src = cans.toDataURL("image/png");
                let imgData = img_png_src.replace(imgType(type),'image/octet-stream');
                let filename = '店铺会员二维码' + '.' + type; //下载图片的文件名
                saveFile(imgData,filename);
            },
            // 获取会员二维码
            getQrcodeForVip(){
                this.$http({
                    url:`stores/${this.curStoreId}/QRCode`,
                    method:"POST",
                    // params:{
                    //     storeId:this.curStoreId
                    // }
                }).then(res=>{
                    console.log(res)
                    // $("#qrcodeForVip").qrcode({
                    //     width:200,
                    //     height:200,
                    //     text:res.data.qrcode
                    // })
                    let qrcode = new QRCode("qrcodeForVip", {
                        text:res.data.qrcode,
                        colorDark : "#000000",
                        colorLight : "#ffffff",
                        correctLevel : QRCode.CorrectLevel.H
                    });
                });
            },
            browserDown(){
                console.log(this.value)
                window.location.herf='www.baidu.com'
            },
            // 复制数据
            copyData: function ( event ) {
                $(event.target).prev().children('input')[0].select();
                document.execCommand("Copy"); // 执行浏览器复制命令
            },
            getQrcode: function ( foo ) {
                $('#qrcode')[0].innerHTML='';

                let qrcode = new QRCode("qrcode", {
                    text: API_BASE_URL+'wechat/member/openid?type=WECHAT-ORDER&storeId='+this.curStoreId,
                    colorDark : "#000000",
                    colorLight : "#ffffff",
                    correctLevel : QRCode.CorrectLevel.H
                });
                
                setTimeout(()=>{
                    this.downloadImg();
                }, 500)
            },

            // 下载图片
            downloadImg: function () {
                this.oDownLoad($('.codeImg img')[0].src);
            },

            oDownLoad: function (url) {
                console.log(this.myBrowser());

                if (this.myBrowser() === "IE") { //IE  //|| myBrowser() === "Edge"
                    // odownLoad.href = "#";

                    // SaveAs5(url);
                    downloadFile("微信点单二维码.jpg", url);
                } else { //!IE 
                    var blob = this.base64Img2Blob(url);
                    url = window.URL.createObjectURL(blob);

                    $('#downloadImg').attr('href', url);
                    $('#downloadImg').attr('download', '微信点单二维码');
                }
            },

            downloadFile: function ( fileName, content ) {
                var blob = base64Img2Blob(content);  
                //支持IE11  
                window.navigator.msSaveBlob(blob, fileName);  
            },


            base64Img2Blob: function (code) {
                var parts = code.split(';base64,');
                var contentType = parts[0].split(':')[1];
                var raw = window.atob(parts[1]);
                var rawLength = raw.length;

                var uInt8Array = new Uint8Array(rawLength);

                for (var i = 0; i < rawLength; ++i) {
                    uInt8Array[i] = raw.charCodeAt(i);
                }

                return new Blob([uInt8Array], {type: contentType}); 
            },

            myBrowser: function () {  
                var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串  
                var isOpera = userAgent.indexOf("OPR") > -1; if (isOpera) { return "Opera" }; //判断是否Opera浏览器 OPR/43.0.2442.991  
              
                //if (userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera) { return "IE"; }; //判断是否IE浏览器   
              
                if (userAgent.indexOf("Firefox") > -1) { return "FF"; } //判断是否Firefox浏览器  Firefox/51.0  
                if (userAgent.indexOf("Trident") > -1) { return "IE"; } //判断是否IE浏览器  Trident/7.0; rv:11.0  
                if (userAgent.indexOf("Edge") > -1) { return "Edge"; } //判断是否Edge浏览器  Edge/14.14393  
                if (userAgent.indexOf("Chrome") > -1) { return "Chrome"; }// Chrome/56.0.2924.87  
                if (userAgent.indexOf("Safari") > -1) { return "Safari"; } //判断是否Safari浏览器 AppleWebKit/534.57.2 Version/5.1.7 Safari/534.57.2  
            }

        },
        created: function () {
            this.configUrl = `${API_BASE_URL}v1/admin/clientGet?storeId=${this.curStoreId}&base=huoxingy.zip`;
            // this.configUrl = `https://images.huoxingy.com/client/1072f5a6-f4ef-11e7-abdc-696684f6a39b.zip`;
            // if(this.storeData.clientUrl){
            //     this.configUrl = this.storeData.clientUrl;
            // }else{
            //     this.$http.get('/stores/'+this.curStoreId).then((res)=>{
            //         this.configUrl = res.data.clientUrl;
            //     });
            // }
            this.batUrl='http://hxypic.oss-cn-hangzhou.aliyuncs.com/client/'+this.curStoreId+'/ie.bat';
        },
        mounted: function () {
            this.hasCall = sessionStorage.getItem("call");
            this.getQrcode();
            this.url = "https://pc-order.huoxingy.com?storeId="+this.curStoreId+"&tableNo="
            // 获取会员固定二维码
            this.getQrcodeForVip();
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../static/css/common.scss';
    @import '../../../../static/css/reset.css';
	@import "createCode.scss";
    .client{
        background: #e66a6a !important;
    }
    .service{
        background: #fe7f30 !important;
    }
</style>



// WEBPACK FOOTER //
// createCode.vue?832c1ff4